import VendorRoutes from './VendorRoutes'
const privateRoutes = [...VendorRoutes]

export default privateRoutes
